/**
 * WHETHER A CLINICAL DEEP LINK CAN POSSIBLY NAME AN OBJECT.
 *
 * The Record, ServiceRequest and Encounter pages each open one object from an
 * address, and an address is a claim by whoever built it. These two answers are
 * what a page checks BEFORE asking the server, because garbage in the address is
 * an invalid link rather than a missing object.
 *
 * What a page says once the server HAS been asked and the read failed belongs to
 * `shared/clinical/ClinicalState`, which owns that decision for all three.
 */

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export function isUuid(value: string): boolean {
  return UUID_RE.test(value)
}

/** The route param when the router matched, else the address's own last word. */
export function lastPathSegment(pathname: string): string {
  return pathname.split('/').filter(Boolean).at(-1) ?? ''
}
